import React from 'react';

const UrgentRequestDisclaimer = ({volume, expectedVolumeMet}) => {
   return ( <div className='mt-1'>
        <p>
           Please note, there may be an additional service fee on your urgent request. This will only apply if the volume of oil in the tank is less than {volume} full.
           If the tank is greater than {volume} full, we will not charge you. The service fee helps us cover the cost of an un-scheduled or urgent run where there is not enough oil.
        </p>
        <div className='mb-1'><b>How does an urgent run work?</b></div>
        <p>
            When we receive an urgent run request, we prioritise the collection. This means that we may need to take the quickest route and not the most 
            efficient route. We will need to re-schedule or delay other runs. An URGENT run request will require you to provide photos as proof to help us prioritise the collection.
        </p>
        <div>Please confirm that you would like to request an urgent run</div>
        {
            expectedVolumeMet &&
            <div>{`<<Because your estimated volume is greater than ${volume} there will be no service charge for this collection>>`}</div>
        }
    </div>);
};
export default UrgentRequestDisclaimer;